import { RoutingConfig } from '@spartacus/core'

export const mbSearchRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      emptySearch: { paths: ['search'] }
    }
  }
}
